<template>
    <dialog-generic :visibility.sync = 'visible' :indicator = 'indicator' min-width = '480px' max-width = '720px' persistent>
        <template v-slot:title>Добавление нового показателя</template>
        <template v-slot:content>
            <v-form v-model = 'validField' class = 'py-2 px-4'>
                <v-text-field
				    label = 'Название поля'
				    v-model = 'metric.name'
				    hint = 'Введите название поля на латинице без специальных символов'
				    :rules = "[rules.required,rules.safe]"
				    clearable
				    counter='20'
				></v-text-field>
				<v-autocomplete
                    ref = 'metric_fields'
	                :items = 'availableMetrics'
                    item-text = 'column_name'
                    return-object
				    multiple
		            chips
		            label = 'Используемые столбцы'
		            hint = 'Выберите столбцы для расчета параметра'
			        v-model = 'metric.fields'
		            :rules = "[rules.required]"
                    @change = 'addFormulaField'
				>
                    <template v-slot:item = '{item}'>
                        <v-row>
                            <v-col>{{item.column_name}}</v-col>
                            <v-col class = 'caption'>{{item.type}}</v-col>
                            <v-col class = 'caption text-center'>{{item.identity}}</v-col>
                        </v-row>
                    </template>
                </v-autocomplete>
                <v-textarea
                    id = 'user_metric_formula'
                    clearable
		            label = 'Формула'
				    v-model = 'metric.formula'
		            :rules = "[rules.required, rules.formulaInterpreted]"
                    validate-on-blur
                    full-width
                    @blur = 'updateBoundedColumns'
				></v-textarea>
            </v-form>
        </template>
        <template v-slot:action>
            <v-btn 
                class = 'px-0 light-blue--text text--darken-2' 
                :loading = 'indicator' 
                block depressed 
                @click = 'addMetric'
                :disabled = '!validField'
            >Добавить</v-btn>
        </template>
    </dialog-generic>
</template>

<script>
    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'

    export default {
        name: 'CreateMetric',
        props: ['visibility', 'viewColumns', 'internalTables'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                visible: this.visibility,
                validField: false,
                metric: {
                    type: 'metric',
                    fields: [],
                    formula: ''
                },
                indicator: false,
                action: false,
                rules: {
	                required: value => !!value || 'Обязательное поле.',
	                email: value => {
	                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	                    return pattern.test(value) || 'Неправильный e-mail.'
	                },
	                safe: value => {
	                    const pattern = /^[a-zA-Z0-9_]*$/
	                    return pattern.test(value) || 'Неверный формат'
                    },
                    formulaInterpreted: value => {
                        let clearedSymbols = value.trim().replace(/ /g,'')
                            .replace(/\+/g, '').replace(/\-/g, '')
                            .replace(/\*/g, '').replace(/\//g, '')
                            .replace(/\(/g, '').replace(/\)/g, '')
                        for (let f of this.metric.fields) {
                            clearedSymbols = clearedSymbols.replace(/f.column_name/g, '')
                        }
                        if (clearedSymbols.length && !/[+-]?\d+(\.\d+)?/.test(clearedSymbols)) {
                            console.log(clearedSymbols)
                            return 'Формула содержит какую-то хуйню'
                        }
                        if (value && (value.includes('*') || value.includes('/')) && !value.includes('(') && (value.includes('+') || value.includes('-'))) {
                            return 'Формула не содержит явных приоритетов применения операторов. Расставьте скобки для указания последовательности применения'
                        }
                        let clearedBrackets = this.removeBracket(value)
                        if (clearedBrackets.includes(')') || clearedBrackets.includes('(') || value.includes('()')) {
                            return 'Формула содержит неправильную последовательность скобок'
                        }
                        return true
                    }
	            }
            }
        },
        methods: {
            addMetric() {
                this.indicator = true;
                let project = this.$store.state.currentProject
                if (typeof this.metric.fields != 'object') {
                    this.metric.fields = JSON.parse(this.metric.fields)
                }
		        this.$http.post(this.$store.getters.endpoint + '/db/project/' + project.project_id + '/metric', {
				    'login': this.$store.getters.userLogin,
                    'project_table': project.project_table,
                    'dataset_name': project.dataset_name,
			        ...this.metric
			    } , {
			        headers: this.$store.state.restrictedHeaders
			    }).then( (r) => {
                    this.indicator = false
                    this.visible = false
                    this.$dataLayer.$emit('enrich', {
                        event: 'crud',
                        data: {
                            type: 'create',
                            target: 'project_metric'
                        },
                        once: false
                    })
                    this.$emit('metricCreated', true)
			    });
			},
            updateBoundedColumns() {
                this.metric.fields = this.metric.fields.filter( (f) => (this.metric.formula || '').includes(f.column_name))
            },
            removeBracket(val) {
                let is_cleared_array = val.match(/\(|\)/g)
                if (!is_cleared_array || is_cleared_array.length <= 1) {
                    return val
                } else {
                    return this.removeBracket(val.replace('(', '').replace(')', ''))
                }
            },
            addFormulaField(val) {
                if (val && val.length && !this.metric.formula.includes(val[val.length - 1].column_name)) {
                    this.metric.formula = this.metric.formula + val[val.length - 1].column_name
                    this.$refs.metric_fields.blur()
                    this.$refs.metric_fields.menuIsActive = false
                    document.querySelector('#user_metric_formula').focus()
                }
            }
        },
        computed: {
            usedTables() {
                return this.metric.fields.map( (f) => f.table_name)
            },
            costMetrics() {
                return this.viewColumns.filter( (c) => c.data_type != 'STRING' && c.data_type != 'DATE' && c.data_type != 'DATETIME')
            },
            availableMetrics() {
                const columns = Object.values(this.internalTables)
                    .flat()
                    .concat(this.viewColumns)
                    .filter( (c) => 
                        c.data_type != 'STRING' && c.data_type != 'DATE' && 
                        c.data_type != 'DATETIME' && !c.data_type.includes('STRING')  && 
                        !c.table_name.includes('_gac_')
                    )
                    .map( (f) => ({
                        ...f, 
                        'type': f.table_name.includes('table_ga') ? 'ga': f.table_name.includes('table_ya')? 'ya': f.table_name.includes('table_ct')? 'ct': 'costs',
                        'identity': f.table_name.split('_').slice(-1)[0]
                    }))
                return columns
            }
        },
        watch: {
            visibility(value) {
                this.visible = value
            },
            visible(value) {
                this.$emit('update:visibility', value);
            }
        }
    }
</script>